// extracted by mini-css-extract-plugin
export default {"map-address":"MapSection_map-address__lBeUa"};